import { typo } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { TypographyPrimitive, type TypographyPrimitiveProps } from "../primitives/TypographyPrimitive";

const styles = stylex.create({
	root: {
		fontSize: typo.titleSecondaryFontSize,
		fontWeight: typo.titleSecondaryFontWeight,
		lineHeight: typo.titleSecondaryLineHeight,
	},
});

export const TitleSecondary = ({ render = <h2 />, inverted = false, ...props }: TypographyPrimitiveProps & { inverted?: boolean }) => {
	return <TypographyPrimitive render={render} {...props} sx={[styles.root, props.sx]} inverted={inverted} />;
};
